import { ICommonResponse, IStudentAverageGrades, IStudentFinalGrades, SubjectData } from 'api/types';
import { IRootState } from 'reducers';
import { createSelector } from 'reselect';

import { IMappedAverageGrade, IMappedFinalGrades } from '../../types';
import { learningYearsSortPredicate } from '../../utils';

export const learningYearFinalPerformanceSelector = createSelector(
  [(state: IRootState) => state.studentFinalGrades],
  (finalGrades): ICommonResponse<IMappedFinalGrades> => {
    return {
      ...finalGrades,
      content: mapLearningYearPerformance(finalGrades.content),
    };
  },
);

export const learningYearAveragePerformanceSelector = createSelector(
  [(state: IRootState) => state.studentAverageGrades],
  (averageGrades) => ({
    ...averageGrades,
    content: mapLearningYearAveragePerformance(averageGrades.content),
  }),
);

export const mapLearningYearAveragePerformance = (data: IStudentAverageGrades): IMappedAverageGrade => ({
  averageMarkFive: data.averageMarkFive,
  subjectsPerformance: data.subjectsRank.map((subject) => ({
    subjectId: subject.subjectId,
    subjectName: subject.subjectName,
    markValue: subject.averageMarkFiveSubject,
  })),
});

function mapLearningYearPerformance(performance: IStudentFinalGrades[]): IMappedFinalGrades[] {
  const sortedPerformanceDesc = [...performance].sort((a, b) =>
    learningYearsSortPredicate(a.yearTitle, b.yearTitle, 'desc'),
  );

  const mappedLearningYearPerformance = sortedPerformanceDesc.map((performance): IMappedFinalGrades => {
    return {
      year: performance.yearTitle,
      averageGrade: performance.averageAllSubjects,
      educationLevel: performance.educationLevel,
      subjects: performance.subjects
        .map((subject) => {
          const subjectData: IMappedFinalGrades['subjects'][number] = {
            subjectId: subject.id,
            subjectName: subject.name,
            markValue: getSubjectGrade(subject),
          };

          if (!subjectData.markValue && subject.yearValue) {
            subjectData.nonMarkValue = subject.yearValue;
          }

          return subjectData;
        })
        // Исключаем значения, у которых не задана оценка
        .filter((subject) => subject.markValue || subject.nonMarkValue),
    };
  });

  return mappedLearningYearPerformance;
}

function getSubjectGrade(subject: IStudentFinalGrades['subjects'][number]): number {
  const {
    yearFivePointValue,
    // Временно убираем привязку к attestationPeriods, задача SP-6835
    // attestationPeriods
  } = subject;

  // если нет yearFivePointValue - будем брать оценку последнего аттестационного периода за этот год
  // (максимальный ИД аттестац периода)
  // const latestAttestationPeriod = attestationPeriods.reduce<
  // IStudentFinalGrades['subjects'][number]['attestationPeriods'][number] | null
  // >((prevPeriod, currentPeriod) => {
  //   if (!prevPeriod) return currentPeriod;
  //   return currentPeriod.id > prevPeriod.id ? currentPeriod : prevPeriod;
  // }, null);

  // const subjectGrade = yearFivePointValue ?? latestAttestationPeriod?.fivePointValue ?? 0;

  return yearFivePointValue ?? 0;
}
